(function () {
    'use strict';
    var BulkTagSubmitCtrl = function ($scope, ajaxCall, xmsNotificationFactory, $uibModalInstance, passedModel) {

        console.log('BulkTagSubmitCtrl init -|-****');
        if (!angular.isDefined(passedModel)) {
            console.log('BulkTagSubmitCtrl passed model undefined');
            passedModel = {};
        }
        $scope.tagModel = {};
        $scope.tagModel = passedModel;

        $scope.ok = function () {
            $uibModalInstance.close(this.tagModel);
        };

        $scope.cancel = function (e) {
            if (angular.isDefined(e)) {
                e.preventDefault();
            }
            $uibModalInstance.dismiss('cancel');
        };

        $scope.submitBulkTagAction = function ($event) {
            console.log('submitBulkTagAction - called');

            var addOrRemoveValue = $scope.tagModel.addOrRemove;
            var objectType = $("input[name='objectType']").val();
            var objectId = [];
            var tagId =  $("input[name='tagId']").val();
            var newTag = $scope.tagModel.newTag;
            var ajaxUrl;

            $event.preventDefault();

            $("input[name='objectId']").each(function(){
                objectId.push($(this).val());
            });

            if(addOrRemoveValue == 'add'){
                ajaxUrl = WEBAPP_PATH + "/tagAdmin/bulkAddTagsSubmit";
            } else if(addOrRemoveValue == 'remove'){
                ajaxUrl = WEBAPP_PATH + "/tagAdmin/bulkRemoveTagsSubmit";
            }

            var data = {
                objectType: objectType,
                tagId: tagId,
                newTag: newTag,
                objectId: objectId
            };

            ajaxCall.getData(ajaxUrl, data)
                .then(
                    function(result) {
                        $('#success').text(result.data);
                        xmsNotificationFactory.bulk([result.data], 'success');
                        $scope.cancel();
                },
                    function(result) {
                        xmsNotificationFactory.bulk([result.data], "danger");
                        $scope.cancel();
                        console.log("Error in BulkAddTagsSubmit.js", result);
                        return false;
                    });

            return false;
        };

    };
    BulkTagSubmitCtrl.$inject = ['$scope', 'ajaxCall', 'xmsNotificationFactory', '$uibModalInstance', 'params'];
    angular.module('app').controller('BulkTagSubmitCtrl', BulkTagSubmitCtrl);
}());